import AxiosApi from "@/config/axios";

const BeneficiaryService = {};

BeneficiaryService.get = () => {
    return AxiosApi({
        url: `/beneficiaries`,
        method: 'get',
    })
}

BeneficiaryService.getTabelValuesByBeneficiaryId = (id) => {
    return AxiosApi({
        url: `/beneficiaries/${id}/table-values`,
        method: 'get',
    })
}

BeneficiaryService.getCPTSApplied = () => {
    return AxiosApi({
        url: `/beneficiaries-cpt`,
        method: 'get',
    })
}



export default BeneficiaryService;